import { AlertOctagon, RefreshCw, WifiOff } from "lucide-react";
import { COCKPIT } from "../../constants/testIds";
import { formatApiError } from "../../api";

// UI_STANDARDS.md Part A: plain-language error + what happened + next step + retry +
// correlation ID shown — never a stack trace/DB detail.
export function ErrorState({ error, onRetry, title = "Couldn't load your cockpit" }) {
  const { message, correlationId } = formatApiError(error);
  return (
    <div className="solid-surface rounded-[14px] p-8 flex flex-col items-center text-center" data-testid={COCKPIT.errorState}>
      <AlertOctagon size={28} style={{ color: "var(--status-overdue-text)" }} className="mb-3" />
      <p className="font-semibold mb-1" style={{ color: "var(--scarlet-text)" }}>{title}</p>
      <p className="text-sm mb-1" style={{ color: "var(--scarlet-text-secondary)" }}>{message}</p>
      {correlationId && (
        <p className="text-xs mb-4 tabular-nums-force" data-testid={COCKPIT.errorCorrelationId} style={{ color: "var(--scarlet-text-secondary)" }}>
          Reference ID: {correlationId}
        </p>
      )}
      {onRetry && (
        <button onClick={onRetry} className="text-sm font-semibold flex items-center gap-1.5 scarlet-focusable" style={{ color: "var(--scarlet-accent)" }}>
          <RefreshCw size={14} /> Try again
        </button>
      )}
    </div>
  );
}

// UI_STANDARDS.md Part A: offline shows last-known + timestamp, never a white screen.
export function OfflineBanner({ lastUpdatedLabel }) {
  return (
    <div
      data-testid={COCKPIT.offlineBanner}
      className="rounded-[10px] px-4 py-2.5 mb-4 flex items-center gap-2 text-sm font-medium"
      style={{ background: "var(--status-expiring-bg)", color: "var(--status-expiring-text)" }}
    >
      <WifiOff size={15} />
      You're offline — showing last known data ({lastUpdatedLabel}).
    </div>
  );
}
